import { ReactNode } from 'react'

import FormattedText from 'shared/ui/FormattedText'

import styles from './NumberedListItem.module.scss'

interface NumberedListItemProps {
  number: string
  header: string
  content: string | ReactNode
}

const NumberedListItem = ({
  number,
  header,
  content
}: NumberedListItemProps) => {
  return (
    <li className={styles.listItem}>
      <div className={styles.topWrapper}>
        <div className={styles.number}>{number}</div>
        <h3 className={styles.header}>
          <FormattedText text={header} />
        </h3>
      </div>

      <div className={styles.content}>{content}</div>
    </li>
  )
}

export default NumberedListItem
